import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ConnieComponent } from '@connect-services/client/components/connie/connie.component';
import { MainTitleComponent } from '@connect-services/client/components/main-title/main-title.component';
import { ActionsEnum } from '@connect-services/client/models/panel.model';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ConnieComponent, MainTitleComponent, RessourcesModule],
    selector: 'app-ai',
    styleUrl: './ai.component.scss',
    templateUrl: './ai.component.html',
})
export class AiComponent {
    protected readonly ActionsEnum = ActionsEnum;
}
